import {z} from "zod/v4-mini"

export const renderNodeBaseSchema = z.strictObject({})
export type RenderNodeBase = {}

export const imageSchema = z.strictObject({
    type: z.union([z.literal("loadImage"), z.literal("computeImage")]),
    data: z.record(z.string(), z.unknown()),
})
export type Image = {
    type: "loadImage" | "computeImage"
    data: object
}

export type ShaderNode = {
    type: string
    inputs: {[name: string]: [ShaderNode, string] | undefined}
    parameters: {[name: string]: unknown | undefined}
    resources?: {[name: string]: Image}
}

export const shaderNodeSchema: z.ZodMiniType<ShaderNode> = z.strictObject({
    type: z.string(),
    get inputs() {
        return z.record(z.string(), z.tuple([shaderNodeSchema, z.string()]))
    },
    parameters: z.record(z.string(), z.unknown()),
    resources: z.optional(z.record(z.string(), imageSchema)),
})
